import { SelectionBoxesCount, MarketTemplate } from "../../data";
export const mapSelectionNames = (marketConfig, dict) => {
    let selectionNames = [];
    const templateName = MarketTemplate[marketConfig.template];
    for (let i = 1; i <= SelectionBoxesCount[marketConfig.template]; i++) {
        let currentSelectionName = dict[`${templateName}_${marketConfig.idLive}_${i}`]
            || dict[`${templateName}_${marketConfig.idPreLive}_${i}`]
            || `${templateName}_${marketConfig.idLive}_${i}`;
        selectionNames.push(currentSelectionName);
    }
    return selectionNames;
};
//# sourceMappingURL=mapSelectionNames.js.map